/**
                   _ooOoo_
                  o8888888o
                  88" . "88
                  (| -_- |)
                  O\  =  /O
               ____/`---'\____
             .'  \\|     |//  `.
            /  \\|||  :  |||//  \
           /  _||||| -:- |||||-  \
           |   | \\\  -  /// |   |
           | \_|  ''\---/''  |   |
           \  .-\__  `-`  ___/-. /
         ___`. .'  /--.--\  `. . __
      ."" '<  `.___\_<|>_/___.'  >'"".
     | | :  `- \`.;`\ _ /`;.`/ - ` : | |
     \  \ `-.   \_ __\ /__ _/   .-` /  /
======`-.____`-.___\_____/___.-`____.-'======
                   `=---='

^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
           佛祖保佑       永无霸葛
           心外无法       法外无心
**/

// 路由设置
const routes = [{
        path: '/',
        redirect: '/index'
    }, {
        path: '/index',
        component: 'index',
        meta: {
            keepAlive: true
        }
    }, {
        path: '/index2',
        component: 'customization'
    },
    {
        path: '/customization',
        component: 'customization'
    },
    {
        path: '/general',
        component: 'general'
    }, {
        path: '/agent/index',
        component: 'acustLoginPay'
    }, {
        path: '/custIndex',
        component: 'customization'
    }, {
        path: '/custLogin',
        component: 'customization'
    }, {
        path: '/custQues',
        component: 'customization'
    }, {
        path: '/freeQues',
        component: 'customization'
    }, {
        path: '/freeLogin',
        component: 'customization'
    }, {
        path: '/product/official',
        component: 'official'
    }, {
        path: '/pay/index',
        component: 'pay'
    }, {
        path: '/product/question',
        component: 'question'
    },
    {
        path: '/product/questionNew/',
        component: 'questionNew'
    },
    {
        path: '/pay/result',
        component: 'result'
    }, {
        path: '/pay/wxres',
        component: 'wxres'
    }, {
        path: '/shop',
        component: 'shop'
    }, {
        path: '/shopFree',
        component: 'shopFree'
    }
]
window.routes = routes

export default routes


// WEBPACK FOOTER //
// ./src/router/routes.js